var React = require('react');

function Chat (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m1675.079 5721.644s-1.259 6.557-17.213 11.4-27.989 4.218-27.989 4.218 12.506-2.758 24.145-15.617 14.493-30 14.493-30-.663 10.333.977 17.832a30.452 30.452 0 0 0 5.587 12.167z","fill":"#54d2df","transform":"translate(-1629.878 -5691.648)"}));
}

Chat.defaultProps = {"height":"45.638","viewBox":"0 0 45.201 45.638","width":"45.201"};

module.exports = Chat;

Chat.default = Chat;
